// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import EmentorArray from '../shared/EmentorArray';

const PEConstructedDraftReport = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Prompt Instructions TL" instructions="What is the constructed response prompt instructions in TL?" />
      <Controller
        control={control}
        name="content.prompt_instructions_tl"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt_instructions_tl} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="Prompt Instructions EN" instructions="What is the constructed response prompt instructions in EN?" />
      <Controller
        control={control}
        name="content.prompt_instructions_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt_instructions_en} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="3" title="Prompt" instructions="What is the constructed response prompt?" />
      <Controller
        control={control}
        name="content.prompt"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="4" title="Summarized Prompt (TL)" instructions="What is the shortened version of the constructed response prompt (in TL) to display prior to schoolhouse response?" />
      <Controller
        control={control}
        name="content.summary_prompt_tl"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.summary_prompt_tl} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="5" title="Summarized Prompt (EN)" instructions="What is the shortened version of the constructed response prompt (in English) to display prior to schoolhouse response?" />
      <Controller
        control={control}
        name="content.summary_prompt_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.summary_prompt_en} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="6" title="Response" instructions="Write the schoolhouse response that will be shown to the student to let them know what their response could have looked like." />
      <Controller
        control={control}
        name="content.response"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.response} />}
      />
    </div>
  );
};

export default PEConstructedDraftReport;